module.exports = __webpack_public_path__ + "img/548.055cecef.jpg";